<script setup>
import SiteLayout from "@/layouts/SiteLayout.vue";
</script>

<template>
  <SiteLayout />
</template>
